import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "60",
  height: "60",
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "30",
      cy: "30",
      r: "27",
      fill: "#23AA71"
    }, null, -1),
    _createElementVNode("path", {
      d: "M18 32L25.3593 41.1991C25.6764 41.5954 26.2874 41.5689 26.5689 41.1466L42 18",
      stroke: "white",
      "stroke-width": "3.75",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render: render }